import React from 'react';
import {Avatar, Button, Descriptions, Divider, Modal, Space, Typography} from 'antd';
import {CalendarOutlined, EditOutlined, MailOutlined, UserOutlined} from '@ant-design/icons';

const { Title, Text } = Typography;

function UserProfileModal({ isOpen, onClose, open, onCancel, onEdit, user }) {
  // 호환: open/onCancel 우선 사용
  const openFinal = typeof open !== 'undefined' ? open : !!isOpen;
  const onCancelFinal = onCancel || onClose || (() => {});

  const displayName = user?.userNm || user?.lgnUserNm || '사용자';
  const displayEmail = user?.eml || user?.email || user?.emlAddr || '-';
  const avatarSrc = user?.profileUrl || user?.avatar;

  return (
    <Modal
      title={
        <Space>
          <UserOutlined />
          <span>사용자 프로필</span>
        </Space>
      }
      open={openFinal}
      onCancel={onCancelFinal}
      footer={[
        <Button key="close" onClick={onCancelFinal}>닫기</Button>,
        <Button key="edit" type="primary" icon={<EditOutlined />} disabled={!onEdit} onClick={() => onEdit && onEdit(user)}>프로필 수정</Button>
      ]}
      width={600}
    >
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <Avatar
          size={88}
          icon={<UserOutlined />}
          src={avatarSrc}
          style={{ backgroundColor: '#1890ff', border: '4px solid #1890ff', marginBottom: 16 }}
        />
        <Title level={3} style={{ margin: '8px 0 4px 0' }}>{displayName}</Title>
        <Text type="secondary">{displayEmail}</Text>
      </div>

      <Divider />

      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label={<Space><UserOutlined /><span>이름</span></Space>}>
          {user?.userNm || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<Space><MailOutlined /><span>이메일</span></Space>}>
          {displayEmail}
        </Descriptions.Item>
        <Descriptions.Item label={<Space><UserOutlined /><span>프로필URL</span></Space>}>
          {user?.profileUrl || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<Space><CalendarOutlined /><span>가입일</span></Space>}>
          {user?.joinDt || '정보 없음'}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}

export default UserProfileModal;
